import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead,
  convert2Routes
} from '@/libs/util'
import router from '@/router'
import config from '@/config'
import Vue from 'vue'
const { homeName } = config

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

export default {
  state: {
    modules: [], // 应用模块
    routes: [], // 动态routes
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead('local'),
    errorList: [],
    hasReadErrorPage: false,
    user: {},
    curNodex: ''
  },
  getters: {
    homeRoute: state => state.homeRoute,
    menuList: (state, getters, rootState) => getMenuByRouter(state.routes, rootState.user.access),
    errorCount: state => state.errorList.length,
    routes: state => state.routes,
    modules: state => state.modules,
    user: state => state.user,
    curNodex: state => state.curNodex
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setcurNodex (state, curNodex) {
      state.curNodex = curNodex
    },
    setModules (state, modules) {
      state.modules = modules
    },
    setRoutes (state, routes) {
      state.routes = routes
    },
    setBreadCrumb (state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    setHomeRoute (state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName)
    },
    setTagNavList (state, list) {
      let tagList = []
      if (list) {
        tagList = [...list]
      } else tagList = getTagNavListFromLocalstorage() || []
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
      let homeTagIndex = tagList.findIndex(item => item.name === homeName)
      if (homeTagIndex !== -1 && homeTagIndex !== 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      } else if (homeTagIndex === -1) {
        tagList.unshift(state.homeRoute)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag (state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag (state, { route, type = 'unshift', notSetLocal }) {
      if (route.meta && route.meta.hideInTabBar) return
      let router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') state.tagNavList.push(router)
        else {
          if (router.name === homeName) state.tagNavList.unshift(router)
          else state.tagNavList.splice(1, 0, router)
        }
        if (!notSetLocal) setTagNavListInLocalstorage([...state.tagNavList])
      }
    },
    setLocal (state, lang) {
      localSave('local', lang)
      state.local = lang
    },
    addError (state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus (state, status = true) {
      state.hasReadErrorPage = status
    }
  },
  actions: {
    addErrorLog ({ commit, rootState }, info) {
      // if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false)
      // const { user: { token, userId, userName } } = rootState
      // let data = {
      //   ...info,
      //   time: Date.parse(new Date()),
      //   token,
      //   userId,
      //   userName
      // }
      // saveErrorLogger(info).then(() => {
      //   commit('addError', data)
      // })
    },
    setRoutes ({commit}, routes) {
      return commit('setRoutes', routes)
    },
    setModules ({commit}, {modules, router}) {
      commit('setModules', modules)
      modules.forEach(module => {
        let routes = module.routes ? module.routes : []
        convert2Routes(routes)
        router.addRoutes(routes)
      })
      return commit('setModules', modules)
    },
    setUser ({commit}, user) {
      return commit('setUser', user)
    },
    logout ({commit}, {router}) {
      return Vue.prototype.$api('app/logout').then(() => {
        window.localStorage.removeItem(config.storage.MODULES)
        window.localStorage.removeItem('tagNaveList')
        window.location = '/login'
        // router.push({name: 'login'})
        setTimeout(() => {
          commit('setUser', {})
        }, 200)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js